import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// change other locale
const userLang = navigator.language || navigator.userLanguage
export default new VueI18n({
  // locale: userLang || process.env.VUE_APP_I18N_LOCALE || 'fr',
  locale: (userLang == 'en-EN') || (userLang == 'en') ? 'en' :
          (userLang == 'fr-FR') || (userLang == 'fr') ? 'fr' :
          (userLang == 'nl-NL') || (userLang == 'nl') ? 'nl' : 'fr' || process.env.VUE_APP_I18N_LOCALE || 'fr',
  

  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fr',
  silentFallbackWarn: process.env.NODE_ENV === 'production',
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  messages: loadLocaleMessages()
})

// Hot updates
if (module.hot) {
  // module.hot.accept(['./locales/en', './locales/fr', './locales/nl'], function () {
  module.hot.accept(['./locales/fr', './locales/nl'], function () {
    // i18n.setLocaleMessage('en', require('./locales/en').default)
    i18n.setLocaleMessage('fr', require('./locales/fr').default)
    i18n.setLocaleMessage('nl', require('./locales/nl').default)
  })
}
